import { useMutation } from "react-query";
import DataService from "../../../../../../Service";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { showSnackbar } from "../../../../../../Components/Snackbar/SnackbarActions";
import { postDataFormatter } from "../HelperFunctions";
import {
  mandatoryFieldsErrorDispatcher,
  properInputFieldsErrorDispatcher,
  errorDispatcher,
} from "../HelperFunctions";
const useColumnsDataUpdater = (tableState) => {
  // Table state
  const {
    setEditRowIndex,
    setActiveRowData,
    setDisableSubmit,
    setNotFilledMandatoryFields,
    updateApiKey,
    noProperInputFields,
    setNoProperInputFields,
    notFilledMandatoryFields,
    setActiveData,
    activeRowData,
    liveViewType,
    columns,
    activeData,
  } = tableState;
  const dispatch = useDispatch();
  const postDataFunc = (postData) => {
    let form_data = new FormData();
    if (liveViewType === "organisation") {
      form_data.append("organisation_id", `${postData["organisation_id"]}`);
    } else {
      form_data.append(
        "partner_profile_id",
        `${postData["partner_profile_id"]}`
      );
    }
    form_data.append("row_update", JSON.stringify(postData["row_update"]));
    return DataService.updateData(form_data, null, updateApiKey);
  };

  const noChangeActionsHandler = () => {
    dispatch(showSnackbar("error", ["Nothing to update"], 1000));
    setEditRowIndex({});
    setNotFilledMandatoryFields([]);
    setNoProperInputFields([]);
    setActiveRowData({});
    setDisableSubmit(false);
  };

  const updateRowFunc = (table) => {
    const { rowIndex, ...newRowData } = activeRowData;
    // Checks if any mandatory fields are missed out
    if (notFilledMandatoryFields.length > 0 || noProperInputFields.length > 0) {
      // if (noProperInputFields.length > 0) {
      //   // A void function call to show snackbar about the improper input fields
      //   properInputFieldsErrorDispatcher(table, dispatch, noProperInputFields);
      // }
      // if (notFilledMandatoryFields.length > 0) {
      //   // A void funtion call to show snackbar about the missing mandatory fields
      //   mandatoryFieldsErrorDispatcher(
      //     table,
      //     dispatch,
      //     notFilledMandatoryFields
      //   );
      // }
      errorDispatcher(
        table,
        dispatch,
        noProperInputFields,
        notFilledMandatoryFields
      );
    } else {
      // Checks if any data change happened
      if (Object.keys(newRowData).length > 0) {
        reset();
        const params = {
          row_update: postDataFormatter(newRowData, columns),
        };
        if (liveViewType === "organisation") {
          params.organisation_id = rowIndex;
        }
        if (liveViewType === "partner") {
          params.partner_profile_id = rowIndex;
        }
        mutate(params);
      } else {
        // action for no data change;
        noChangeActionsHandler();
      }
    }
  };
  const { isLoading, isError, mutate, reset } = useMutation({
    mutationFn: postDataFunc,
    mutationKey: "live_view_data",
    onSuccess: () => {
      const { rowIndex, ...newRowData } = activeRowData;
      setActiveData((old) => {
        return old.map((row) => {
          if (row.id === rowIndex) {
            return {
              ...row,
              ...newRowData,
            };
          }
          return row;
        });
      });
      setEditRowIndex(null);
      const nameElement = activeData?.find((el) => el.id === rowIndex);

      const nameFields = {
        partner: "PartnerProfile_full_name",
        organisation: "Organisation_organisation_name",
      };
      const name = nameElement[nameFields[liveViewType]] || "";
      dispatch(
        showSnackbar(
          "success",
          ["Data updated successfully" + (name ? " for " + name : "")],
          1000
        )
      );
      setActiveRowData({});
      setNotFilledMandatoryFields([]);
      setNoProperInputFields([]);
      setDisableSubmit(false);
      reset();
    },
    onError: () => {
      dispatch(
        showSnackbar(
          "error",
          ["Something went wrong while uploading data", "Please try again"],
          1000
        )
      );
    },
  });
  return { isLoading, isError, mutate, reset, updateRowFunc };
};
export default useColumnsDataUpdater;
